import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import "./App.css";
import LandingPage from "./components/LandingPage";
import Footer from "./components/Footer";
import Header from "./components/Header";
import ContactUs from "./components/ContactUs";

function App() {
  const appRouter = createBrowserRouter([
    {
      path: "/",
      element: <AppContainer />,
      children: [
        { path: "/", element: <LandingPage /> },
        { path: "/contact", element: <ContactUs /> },
      ],
    },
    { path: "*", element: <>Page Not Found</> },
  ]);

  return (
    <RouterProvider router={appRouter}>
      <AppContainer />
    </RouterProvider>
  );
}

const AppContainer = () => {
  return (
    <div className="w-[100%] min-h-[400px] bg-[#f8f4ed] px-6 font-sans">
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
};

export default App;
